import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { isDraftSpace } from "@circle-react/helpers/spaceHelpers";
import { useMobileWebFlags } from "@circle-react/hooks/useMobileWebFlags";
import type { Space } from "@circle-react/types";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Typography } from "@circle-react-uikit/Typography";
import { spaceIconsV3 } from "./useSpaceOptionsIcons";

export interface InviteMemberSpaceOptionsProps {
  onInviteMember: () => void;
  space: Space;
}

export const InviteMemberSpaceOptions = ({
  space,
  onInviteMember,
}: InviteMemberSpaceOptionsProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const { isMobileWebNewSpaceCustomizationUIEnabled } = useMobileWebFlags();

  const label = !isDraftSpace(space)
    ? t("space_header.invite_member")
    : t("customize_space.add_waitlist");

  const { inviteMemberIcon } = spaceIconsV3;

  if (isMobileWebNewSpaceCustomizationUIEnabled) {
    return (
      <button
        type="submit"
        className="flex w-full items-center justify-between px-5 py-2.5"
        onClick={onInviteMember}
      >
        <div className="flex items-center gap-4">
          <Icon type={inviteMemberIcon} size={20} className="text-default" />
          <Typography.LabelSm color="text-light" weight="medium">
            {t("space_header.invite_member")}
          </Typography.LabelSm>
        </div>
        <Icon type="16-chevron-right" size={16} className="text-default" />
      </button>
    );
  }

  return (
    <Dropdown.IconWithBadgeList
      options={[
        {
          value: t("space_header.invite_member"),
          label,
          onClick: isViewOnlyMasquerading ? noop : onInviteMember,
          icon: inviteMemberIcon,
          iconSize: 20,
        },
      ]}
    />
  );
};
